<template>
  <section class="wrapper-breadcrumb">
    <div class="ui container">
      <div class="wrap-breadcrumb">
        <div class="wrap-title-breadcrumb">
          <a v-if="!hideBack" class="tui ui icon button" @click="$router.go(-1)">
            <t-icon :icon="['far', 'long-arrow-left']" />
          </a>
          <t-placeholder v-if="loading" class="title-loading" :lines="1" />
          <h1 v-else class="title-two" v-text="title" />
        </div>
        <div class="wrap-actions-breadcrumb">
          <button v-if="titleButton" :disabled="!hasCampaign" class="tui ui button primary" @click="action" v-text="titleButton" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleButton: {
      type: String,
      default: ''
    },
    hideBack: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      loading: ({ breadcrumb }) => breadcrumb.loading,
      isVisibleModal: ({ modal }) => modal.isVisibleModal,
      listPeople: ({ people }) => people.listPeople,
      hasCampaign: ({ campaign }) => campaign.campaign
    })
  },
  methods: {
    action () {
      // eslint-disable-next-line vue/require-explicit-emits
      this.$emit('action')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";

.wrapper-breadcrumb {
  border-bottom: 1px solid $border-color;
  box-sizing: border-box;

  .wrap-breadcrumb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;


    .wrap-title-breadcrumb {
      display: flex;
      align-items: center;

      .title-loading {
        width: 350px;
        height: 20px;
      }

      .title-two {
        font-weight: 700;
        font-size: 25px;
        line-height: 36px;
        margin-top: 0;
      }

      .icon {
        margin-right: 15px;
      }
    }

    .wrap-actions-breadcrumb {
      .button {
        margin-left: 15px;
      }
    }
  }
}

</style>
